import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import styles from "./advantagesBanner.module.scss";
 
const advantages = [
  {
    title: "Bessere Preise",
    Image: props => (
      <StaticImage
        src="../../images/section5-img2.png"
        imgClassName={styles.image}
        alt="Bessere Preise"
      />
    ),
    description:
      "Durch unser europaweites Netzwerk aus über 400 Schrotthändlern und Werken &amp; Recyclern finden wir den passenden Abnehmer für Ihr Altmetall.",
  },
  {
    title: "All-in-One Service",
    Image: props => (
      <StaticImage
        src="../../images/section5-img1.png"
        imgClassName={styles.image}
        alt="All-in-One Service"
      />
    ),
    description:
      "Als voll lizenzierter Schrotthändler bieten wir einen Komplettservice vom Angebot über den Verkauf, Transport und Logistik bis hin zur Auszahlung.",
  },
  {
    title: "Volle Sicherheit",
    Image: props => (
      <StaticImage
        src="../../images/section5-img3.png"
        imgClassName={styles.image}
        alt="Volle Sicherheit"
      />
    ),
    description:
      "Wir bieten eine verlässliche Abwicklung und volle Transparenz bei der Qualitätskontrolle der geprüften Altmetalle - egal ob Sie verkaufen oder kaufen wollen.",
  },
];
const AdvantagesBanner = () => (
  <div className={styles.yourAdvantagesBanner}>
    <div className={styles.bannerBackground}>
      <div className={styles.blueArea}></div>
      <div className={styles.diagonalLineArea}></div>
    </div>
    <h3>SCHROTT SERVICE</h3>
    <h2>Ihre Vorteile</h2>
    <div className={styles.wContainer}>
      {advantages.map(item => (
        <div className={styles.card}>
          <div className={styles.orangeLine}></div>
          <div>
            <item.Image />
          </div>
          <span className={styles.title}>{item.title}</span>
          <p className={styles.description}>{item.description}</p>
        </div>
      ))}
    </div>
  </div>
);

export default AdvantagesBanner;
